import React from 'react';
import { Link } from 'react-router-dom';
import PageSection from '../components/PageSection';
import ServiceGrid from '../components/ServiceGrid';
import { HERO_DESCRIPTION, HERO_EYEBROW, TAGLINE } from '../constants/site';
import SolutionsHighlights from './sections/SolutionsHighlights';
import SolutionsProducts from './sections/SolutionsProducts';
import SolutionsTeam from './sections/SolutionsTeam';
import './Solutions.css';

const Solutions = () => (
  <main className="solutions-page">
    <section className="solutions-hero">
      <div className="solutions-hero__inner">
        <span className="solutions-hero__eyebrow">{HERO_EYEBROW}</span>
        <h1 className="solutions-hero__title">{TAGLINE}</h1>
        <p className="solutions-hero__description">{HERO_DESCRIPTION}</p>
        <Link to="/contact" className="solutions-hero__cta">
          Request a quote
          <i className="fa-solid fa-arrow-right" aria-hidden="true" />
        </Link>
      </div>
    </section>

    <PageSection
      id="materials"
      eyebrow="Materials"
      title="Built for durability and visibility"
      description="We use premium materials engineered for Laos roads, weather conditions, and long-term public safety performance."
    >
      <SolutionsHighlights />
    </PageSection>

    <PageSection
      id="services"
      eyebrow="Services"
      title="Complete road safety solutions"
      description="From paint and signage to traffic systems — everything you need for safer roads and workplaces."
    >
      <ServiceGrid />
    </PageSection>

    <PageSection
      id="products"
      eyebrow="Product range"
      title="Signage and road marking products"
      description="Explore our safety signs and road paint solutions used across public and private projects."
    >
      <SolutionsProducts />
    </PageSection>

    <PageSection
      id="team"
      eyebrow="Our team"
      title="People behind every project"
      description="A committed team delivering quality road safety work across Laos."
    >
      <SolutionsTeam />
    </PageSection>
  </main>
);

export default Solutions;
